<template>

  <div>

    <master-data-form ref="CreateForm" mode="create" :on-update="reload"/>
    <master-data-form ref="UpdateForm" mode="update" :on-update="reload"/>
    <driver-group-form ref="CreateDriverGroupForm" mode="create" :on-update="reload"/>
    <driver-group-form ref="UpdateDriverGroupForm" mode="update" :on-update="reload"/>

    <master-data-select-form ref="MasterDataSelectForm" mode="load" :on-update="reload"/>

    <md-card>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-5">

          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBox" >
              <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Rev. Windows"
                                                :init-value="searchRequest.receivingWindow"
                                                :on-item-changed="handleWindowsChanged"
                                                >
              </auto-complete-master-data-select>
            </div>
            <div>
              <md-checkbox v-model="showOnlyActive">
              <label>Show Only Active Items</label>
              </md-checkbox>
            </div>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBox">
              <auto-complete-stc-driver-group-select
                      label="Driver Group"
                      :options="stcDriverGroupOption"
                      v-model="searchRequest.driverGroup"
               >
              </auto-complete-stc-driver-group-select>
            </div>
          </div>
          <div class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBox">
              <auto-complete-select
                    :options="drivers"
                    label="Driver"
                    :value="searchRequest.driverId"
                    :on-item-changed="handleDriverRequestChanged"
                >
              </auto-complete-select>
            </div>
          </div>


      

          
        <div class="search2" style="margin-left:100px;">
           <md-button class="md-raised optionExtender" @click="doNew" :disabled="getPermission.stcAuditOnly.view">New</md-button>
           <md-button class="btn-search-schedule md-primary md-raised optionExtender" @click="doSearch">Search</md-button>
           <md-button class="md-raised optionExtender" @click="doClear">Clear</md-button>
           <md-button v-if="debug" class="md-raised optionExtender" @click="doTest">Test</md-button>
        </div>
        
          
         
          <div style="margin-left:1450px; margin-top: -200px;">
          </div>  
        </div>
      </md-card-content>
    </md-card>
    


    <br/>

    <calling-api path="/api/w/stc/WebSearchDriverGroup">

      <pagination :items="getSortedDriverGroups">
        <template slot-scope="{pageItems}">
          <md-card class="data-table-container">
            <div class="outer-container">
             <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <!--<th class="header-cell w10">Seq No</th>-->
                      <th class="header-cell w5">Sales Office</th>
                      <th class="header-cell w5">Rec Window</th>
                      <th class="header-cell w10">Driver Group</th>
                      <th class="header-cell w5">Driver Id</th>
                      <th class="header-cell w10">Driver Name</th>
                      <th class="header-cell w10">User Name</th>
                      <th class="header-cell w3">Active</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                      
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      
                      <!--<td class="body-cell w10">{{item.seqNo}}</td>-->
                      <td class="body-cell w5">{{item.salesOffice}}</td>
                      <td class="body-cell w5">{{item.recWindow}}</td>
                      <td class="body-cell w10">{{item.driverGroup}}</td>
                      <td class="body-cell w5">{{item.driverId}}</td>
                      <td class="body-cell w10">{{item.driverName}}</td>
                      <td class="body-cell w10">{{item.userName}}</td>
                      <td class="body-cell w3">{{item.active}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                      
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </md-card>

        </template>
      </pagination>
    </calling-api>
  </div>

</template>
<style scoped>
  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-size: 23px;
    display: inline-block;
    background-color: lightgray;
    margin-left: 300px;
    margin-top: 15px;
    -moz-osx-font-smoothing: grayscale;
  };
  #divider {
    height: 50px;
    width: 5px;
    background-color: black;
    display: inline-block;
  };
  .optionExtender {
    margin-left: 300px;
  };
  .optionExtender:hover{opacity:0.5};
  .searchTagName {
    margin-top: -15px;
    margin-left: 50px;
    display: inline-block;
  };
  .search {
    margin-left:10px;
  };
  .search2 {
    margin-left:100px;
  };
  .inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
  .inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
      
  }

</style>
<script>
  import MasterDataForm from '../components/MasterDataForm.vue';
  import MasterDataSelectForm from '../components/MasterDataSelectForm.vue';
  import AutoCompleteStcDriverGroupSelect from '../components/AutoCompleteStcDriverGroupSelect.vue';
  import DriverGroupForm from '../components/DriverGroupForm.vue';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => ({
    group: "GST_CARRIER",
    tagId: null,
    tagName: null,
 
  });

  const getInitSearchRequest = () => ({
    group: "GST_CARRIER",
    tagId: null,
    tagName: null,
  });

  const initSearchDriverGroup = () => ({
     seqNo: null,
     driverGroup: null,
     userName: null,
     driverId: null,
     active: true,
     driverName: null,
     recWindow: null
  });

  const getInitSearch = () => ({
    receivingWindow: null,
    salesOffice: null,
    driverId: null,
    driverGroup: null,
  });

  const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
  });

  export default {
    data: () => ({
      selectedGroup: "GST_CARRIER",
   
      showOnlyActive: true,
      isload: false,
      isApp: false,
      isYG: false,
      isGeneral: false,
      isLocation: false,
      isCarrier: true,
      isCustomer: false,
      isRoute: false,
      isVendor: false,
      isLease: false,
      isRateBill: false,
      isRateCost: false,
      masterDatas: [],
      DataForm: getInitialDataForm(),
      searchRequest: getInitSearchRequest(),
      tagId: '',
      searchDriverGroupReq: initSearchDriverGroup(),
      searchRequest: getInitSearch(),
      searchDriverSearchReq: getInitDriverSearch(),
      stcDriverGroups: [],
      stcDriverGroupOption: [],
      drivers: [],
      driverIds: [],
      driverNames: [],
      driverContent: [],
      allDrivers: [],
      debug: false
    }),
    components: {
      MasterDataForm,
      MasterDataSelectForm,
      AutoCompleteStcDriverGroupSelect,
      DriverGroupForm
    },
    computed: {
      ...mapGetters([
        'getPermission',
        'getSTCDriverGroup',
        'getGSTDriverMaster'
    
      ]),
      filteredMasterDatasByActive() {
        if (this.showOnlyActive) {
          return _(this.masterDatas)
            .filter(it => it.active);
        }
        return this.masterDatas;
      },
      getAllMasterGroups() {
        console.log("getAllMasterGroups");
        return _(this.filteredMasterDatasByActive || [])
          .chain()
          .pluck('group')
          .uniq()
          .sortBy(it => it)
          .value();
      },
      getFilteredMasterDatas() {
        //this.isload = false;
        console.log(JSON.stringify(this.searchRequest));
        if (!this.DataForm.tagId)
           this.DataForm.tagId = '';
        if (!this.DataForm.tagName)
           this.DataForm.tagName = '';

        console.log("getFilteredMasterDatas tagId: " + this.DataForm.tagId);
        console.log("getFilteredMasterDatas tagName: " + this.DataForm.tagName);
     



  
        console.log("getFilteredMasterDatas isLoad: " + this.isload);
        if (this.isload)
        {
           console.log("tagId: " + this.DataForm.tagId.toString());
           console.log("tagName: " + this.DataForm.tagName.trim());
           return  _(this.filteredMasterDatasByActive)
            .filter(it => (((this.selectedGroup) && (it.group === this.selectedGroup)) || ((!this.selectedGroup) && (it.group !== null)))
                  && (((this.DataForm.tagId !== '') && (it.tagId.includes(this.DataForm.tagId))) || ((this.DataForm.tagId === '') && (it.tagId !== null)))
                  && (((this.DataForm.tagName !== '') && (it.tagName.trim().includes(this.DataForm.tagName.trim()))) || ((this.DataForm.tagName === ''))   )
            )
                     
        }
        else
        {
          console.log("isLoad is false: " + this.isload);
          if (this.selectedGroup)
           return _(this.filteredMasterDatasByActive)
               .filter(it => it.group === this.selectedGroup);
          else
           return _(this.filteredMasterDatasByActive);
        }

      },
      getSortedMasterDatas() {
          return _(this.getFilteredMasterDatas)
            .sortBy(it => it.group);
      },

      getSortedDriverGroups() {
          return _(this.stcDriverGroups)
             .sortBy(it => it.driverGroup);
      },
    },
    watch: {

      selectedGroup() {
        //if (this.isload) {
        switch(this.selectedGroup) {
          case "GST_CARRIER":
             this.$nextTick(() => {
               this.isApp = false; 
               this.isYG = false;
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = true;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false
             });
             break;

          default:
             this.$nextTick(() => {
               this.isApp = false; 
               this.isYG = false;
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = true;
               this.isCustomer = false;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false
             });
        }
        //}
        //this.isload = false;
      },
      masterDatas() {
        this.$nextTick(() => {
          this.updateTableHeight();
        });
      },
    },
    async mounted() {
      await this.reload();
    },
    methods: {

      async reload() {
        // const masterDatas = await api.post('/api/w/masterData',
        // {groups:[
        //   "GST_CARRIER"

        //   ]});
        // this.masterDatas = masterDatas;
        console.log("call reload");
        //const dgroups = await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
        const dgroups = await newAPIPost('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
          this.stcDriverGroups = driverGroup;
        })
        console.log("stc driver groups: " + JSON.stringify(this.stcDriverGroups));
        if (this.stcDriverGroups) {
          this.stcDriverGroups.forEach( (val) => {
              const p_driverGrp = this.stcDriverGroupOption.filter( it => it === val.driverGroup);
              if (p_driverGrp.length == 0)
                 this.stcDriverGroupOption.push(val.driverGroup);
          })
        }      
        console.log("dispatch driver");
        this.searchDriverSearchReq.driverOffice = "STC";
        this.searchDriverSearchReq.defaultSalesOffice = "LGB";
        this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
        this.updateDrivers(this.getGSTDriverMaster); 
      },
      async updateDrivers(itemsSource) {
           console.log("update drivers itemsource: " + JSON.stringify(itemsSource));
           console.log("update drivers itemsource with filter: " + JSON.stringify(itemsSource.filter(it => it.driverOffice == "STC")));
           var items = [];
           this.allDrivers = [];
           if (itemsSource && itemsSource.length > 0)
              items = itemsSource.filter( it => it.driverOffice == "STC");
              //this.allDrivers = items;
           //var items = itemsSource;
           if (items && items.length > 0) {
              console.log("load driver info from cached");
              items.forEach( (it) => {
                var driverInfo = it.shortId + "(" + it.userName + ")";
                this.drivers.push(driverInfo);
                this.driverIds.push(it.driverId);
                this.driverNames.push(it.userName);
                this.driverContent.push(driverInfo);
              });
              this.allDrivers = items;
           } else {
              console.log("load driver info from db");
              this.searchDriverSearchReq.driverOffice = "STC";
              this.searchDriverSearchReq.defaultSalesOffice = "LGB";
              //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
              await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        //driverinfo = driverinfo.filter((it) => {it.driverOffice == "STC"});
                        this.allDrivers = driverinfo;
                        driverinfo.forEach( (it) => {
                            console.log("driver: " + it.shortId);
                            var driverInfo = it.shortId + "(" + it.userName + ")";
                            this.drivers.push(driverInfo);
                            this.driverIds.push(it.driverId);
                            this.driverNames.push(it.userName);
                            this.driverContent.push(driverInfo);
                        })
                    }
                 });

           }
           //console.log("drivers: [[" + this.drivers + "]]");
           console.log("all drivers: " + JSON.stringify(this.allDrivers));
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      toggleCreate() {
        this.$refs.MasterDataSelectForm.openDialog();
      },
      async toggleUpdate(item) {
        //this.$refs.UpdateForm.openDialog(item);
        var drivergroup = this.getSortedDriverGroups.filter((it) => it.driverGroup == item.driverGroup);
        this.$refs.UpdateDriverGroupForm.openDialog(this.stcDriverGroupOption,this.allDrivers,item.driverGroup,drivergroup);
        console.log("call update api");
        // this.searchDriverGroupReq.driverGroup = item.driverGroup;
        // await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((drivergroup) => {
        //         //this.driversinGroup = driverGroup;
        //         //console.log('driversingroup: ', this.driversinGroup);
        //         this.$refs.UpdateDriverGroupForm.openDialog(this.stcDriverGroupOption,this.allDrivers,item.driverGroup,drivergroup)
        //    })

      },
      async doSearch() {
        console.log("reload datagrid");
        //console.log(this.DataForm.tagId);
        //this.$nextTick(() =>
        //this.isload = true);
        ////this.isload = true
        console.log("search driver group: " + this.searchRequest.driverGroup);
        console.log("search driver: " + this.searchRequest.driverId + ", drivername: " + this.getDriverName(this.searchRequest.driverId));
        this.searchDriverGroupReq.driverGroup = this.searchRequest.driverGroup;
        if (this.searchRequest.driverId && this.searchRequest.driverId != "")
        {
           this.searchDriverGroupReq.driverName = this.getDriverName(this.searchRequest.driverId);
        }
        else {
           this.searchDriverGroupReq.driverName = null;
        }
        this.searchDriverGroupReq.recWindow = this.searchRequest.receivingWindow;
        //const dgroups = await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
        const dgroups = await newAPIPost('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
          this.stcDriverGroups = driverGroup;
        })
        
      },
      doClear() {
        this.isload = false;
        // console.log("tagId: " + document.getElementById("tagId").innerHTML);
        // console.log("tagId value: " + document.getElementById("tagId").value);
        // console.log("tagName value: " + document.getElementById("tagName").value);
        // console.log("doClear isload: " + this.isload);
        // this.selectedGroup = "GST_CARRIER";
        // this.DataForm.group = "GST_CARRIER";
        // this.DataForm.tagId = '';
        // this.DataForm.tagName = '';

        // this.DataForm = getInitialDataForm();         
        // this.searchRequest = getInitSearchRequest();
        //  _(this.$el.querySelectorAll('button.md-input-action.md-clear')).each((it) => {
        //    it.click();
        //  });

        // console.log(this.DataForm);
        _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
          });
          this.$nextTick(() => {
            this.searchRequest = getInitSearch();
            this.searchRequest.salesOffice = 'LGB';
          });

      },
      doNew() {
        var items = [];
        console.log("do new");
        this.$refs.CreateDriverGroupForm.openDialog(this.stcDriverGroupOption,this.allDrivers,null,null);
      },
      doTest() {
        var title = "Test"
        var settings = ""
        var width;
        var height;
        var leftPos;
        var topPos;
        var userWidth = screen.availWidth;
        var userHeight = screen.availHeight;
        width =  400;
        height = 200;
        //leftPos = (userWidth - width) /2;
        //leftPos = 1500;
        leftPos = userWidth - 500;
        topPos = (userHeight - height) /2;

        settings += 'left=' + leftPos + ',top=' + topPos + ',width=' + width + ',height=' + height;
        settings += ',scrollbars=yes';

        window.open("http://localhost:8080/#/dispatch/load", title, settings,true);           
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      handleWindowsChanged(id) {
        this.searchRequest.receivingWindow = id;
      },
      handleDriverRequestChanged(id) {
        this.searchRequest.driverId = id;
      },
      getDriverName(searchDriver) {
        if (searchDriver && searchDriver.indexOf("(") > 0) {
           return searchDriver.substr(0,searchDriver.indexOf("("));
        }
        else return searchDriver;
      }
    },
  };


</script>
